import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptStorno: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconReceiptStorno"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.5291L7.27961 19.9901L9.66667 22.2919L12 20.0419L14.3333 22.2919L16.7204 19.9901L20 22.5291V2H4ZM8 14H16V15.5H8V14ZM14.9357 7.375L13.875 6.31434L12 8.18934L10.125 6.31434L9.06434 7.375L10.9393 9.25L9.06434 11.125L10.125 12.1857L12 10.3107L13.875 12.1857L14.9357 11.125L13.0607 9.25L14.9357 7.375Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptStorno;
